import { Box, Typography, ToggleButtonGroup, ToggleButton } from '@mui/material';
import { sectionLabelSx, separatorSx, toggleBtnSx } from './noteOptionsSx';
import { useContentPanelContext } from '../../../contexts/ContentPanelContext';
import noteOptionsPanelEngine from './Core/NoteOptionsPanelEngine';
import { useNoteOptionsPanel } from './Core/useNoteOptionsPanel';

/**
 * @param {object} props
 * @param {object} props.entry
 * @param {boolean} props.isTemplate
 * @param {boolean} props.isJson
 * @param {string} [props.panelId='default']
 */
export default function NoteOptionsPanelToggles({ entry, isTemplate, isJson, panelId = 'default' }) {
    const { isEditing } = useContentPanelContext();
    const { viewMode, bgMode } = useNoteOptionsPanel(panelId);

    return (
        <>
            <Typography sx={sectionLabelSx}>State</Typography>
            <Box sx={{ px: 1.5, pb: 0.5 }}>
                <ToggleButtonGroup
                    value={entry?.stateId ?? 0}
                    exclusive
                    onChange={(_, val) => { if (val !== null) noteOptionsPanelEngine.setEntryState(entry, val, panelId); }}
                    size="small"
                    sx={{ gap: 0.5 }}
                >
                    <ToggleButton value={0} sx={toggleBtnSx}>Active</ToggleButton>
                    <ToggleButton value={1} sx={toggleBtnSx}>Completed</ToggleButton>
                    <ToggleButton value={2} sx={toggleBtnSx}>Hidden</ToggleButton>
                </ToggleButtonGroup>
            </Box>

            <Typography sx={{ ...sectionLabelSx, ...(isEditing ? { opacity: 0.35 } : {}) }}>View</Typography>
            <Box sx={{ px: 1.5, pb: 0.5 }}>
                <ToggleButtonGroup
                    value={viewMode}
                    exclusive
                    onChange={(_, val) => { if (val) noteOptionsPanelEngine.setViewMode(entry, val, panelId); }}
                    size="small"
                    disabled={isEditing}
                    sx={{ gap: 0.5 }}
                >
                    {isTemplate && <ToggleButton value="template" sx={toggleBtnSx}>Template</ToggleButton>}
                    <ToggleButton value="md"    sx={toggleBtnSx}>MD</ToggleButton>
                    <ToggleButton value="plain" sx={toggleBtnSx}>Plain</ToggleButton>
                    <ToggleButton value="html"  sx={toggleBtnSx}>HTML</ToggleButton>
                    {isJson && <ToggleButton value="json" sx={toggleBtnSx}>JSON</ToggleButton>}
                </ToggleButtonGroup>
            </Box>

            <Typography sx={{ ...sectionLabelSx, ...(isEditing ? { opacity: 0.35 } : {}) }}>Background</Typography>
            <Box sx={{ px: 1.5, pb: 0.5 }}>
                <ToggleButtonGroup
                    value={bgMode}
                    exclusive
                    onChange={(_, val) => { if (val) noteOptionsPanelEngine.setBgMode(val, panelId); }}
                    size="small"
                    disabled={isEditing}
                    sx={{ gap: 0.5 }}
                >
                    <ToggleButton value="canvas" sx={toggleBtnSx}>Canvas</ToggleButton>
                    <ToggleButton value="dark"   sx={toggleBtnSx}>Dark</ToggleButton>
                </ToggleButtonGroup>
            </Box>

            <Box sx={separatorSx} />
        </>
    );
}
